import React from 'react';
import {
  CContainer,
  CListGroup,
  CListGroupItem,
  CCard,
  CCardBody,
  CCardTitle,
  CCardText,
  CLoadingButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CButton,
} from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import {cilX} from '@coreui/icons';
import {
  Map,
  useApiIsLoaded,
  useMap,
  MapControl,
  ControlPosition,
} from '@vis.gl/react-google-maps';
import MapMyFieldDrawingTools from './MapMyFieldsDrawingTools';
import MapLoadingSpinner from '../shared/MapLoadingSpinner';
import styles from './Mapping.module.css';
import {
  initMapMyFieldsInterface,
  userTappedDrawFieldBooundaries,
  userSelectedNonMappedFarmField,
  fetchDigiFarmFields,
  submitNonMappedFarmFields,
  completeNonMappedFarmFieldsSubmission,
  setGoogleMappingSessionCleared,
  userTappedResetDrawing,
  submitNonMappedFarmFieldsWithUserDrawings,
  handleNonMappedFarmFieldsBoundsChange,
  hideMapMyFieldsSuccessModal,
} from './mapping-actions';
import _ from 'lodash';
import html2canvas from 'html2canvas';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

const MapMyFields = () => {

  const dispatch = useDispatch();

  const mapDivRef = React.useRef(null);

  const mapApiIsLoaded = useApiIsLoaded();

  const map = useMap();

  const {
    sidebarVisible,
    sidebarUnfoldable,
  } = useSelector(state => state.userSettings);

  const {
    showDrawFieldBoundaryControls,
    fetchingFarmFields,
    nonMappedFarmFields,
    selectedNonMappedFarmField,
    fetchingDigiFarmFields,
    nonMappedDigiFarmFields,
    submittingNonMappedFarmFields,
    nonMappedHiResDigiFarmFields,
    successfullySubmittedNonMappedFarmFields,
    clearPriorGoogleMappingSession,
    mapMyFieldsSuccessModalIsVisible,
  } = useSelector(state => state.mapping);

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  const [windowHeight, setWindowHeight] = React.useState(window.innerHeight);

  const [selectedFarmFields] = React.useState([]);
  
  React.useEffect(() => {
    dispatch(initMapMyFieldsInterface());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize)
  }, []);

  React.useEffect(() => {
    if (mapApiIsLoaded === true && map !== null) {
      map.data.addListener('click', handleMapDataClick);
      map.data.setStyle(setStyles);
    }
  }, [mapApiIsLoaded, map]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (map !== null) {
      if (showDrawFieldBoundaryControls === true) {
        map.data.forEach((feature) => {
          map.data.remove(feature);
        });
      }
      else if (map.zoom >= 14) {
        const ne = map.getBounds().getNorthEast();
        const sw = map.getBounds().getSouthWest();
        dispatch(fetchDigiFarmFields(sw.lng(), sw.lat(), ne.lng(), ne.lat(), false));
      }
    }
  }, [showDrawFieldBoundaryControls, map]); // eslint-disable-line react-hooks/exhaustive-deps
  
  React.useEffect(() => {
    if (map !== null && showDrawFieldBoundaryControls === false) {
      map.data.forEach((feature) => {
        map.data.remove(feature);
      });
      nonMappedDigiFarmFields.forEach((farmField) => {
        map.data.addGeoJson(farmField);
      });
    }
  }, [nonMappedDigiFarmFields, map, showDrawFieldBoundaryControls]);

  React.useEffect(() => {
    if (nonMappedHiResDigiFarmFields.length === 0) {
      return;
    }
    if (map !== null  && showDrawFieldBoundaryControls === false) {
      map.data.forEach((feature) => {
        map.data.remove(feature);
      });
      var digiFields = [];
      selectedFarmFields.forEach((field) => {
        var bounds = new window.google.maps.LatLngBounds();
        field.getGeometry().forEachLatLng((latLng) => {
          bounds.extend(latLng);
        });
        var center = bounds.getCenter();
        digiFields.push({
          centerLatitude: center.lat(),
          centerLongitude: center.lng(),
        });
      });
      nonMappedHiResDigiFarmFields.forEach((farmField) => {
        map.data.addGeoJson(farmField);
      });
      setTimeout(async () => {
        html2canvas(map.getDiv(), {useCORS: true,}).then((canvas) => {
          const base64 = canvas.toDataURL('image/png');
          dispatch(completeNonMappedFarmFieldsSubmission(map.getCenter().lat(), map.getCenter().lng(), base64, digiFields));
        });
      }, 500);
    }
  }, [nonMappedHiResDigiFarmFields, map, showDrawFieldBoundaryControls]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (map !== null && clearPriorGoogleMappingSession === true) {
      selectedFarmFields.splice(0, selectedFarmFields.length);
      map.data.forEach((feature) => {
        map.data.remove(feature);
      });
      dispatch(setGoogleMappingSessionCleared());
    }
  }, [clearPriorGoogleMappingSession, map]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleMapDataClick = (event) => {
    var index = selectedFarmFields.findIndex(field => field.getId() === event.feature.getId());
    if (index > -1) {
      selectedFarmFields.splice(index, 1);
      map.data.overrideStyle(event.feature, {fillColor: 'green',});
    }
    else {
      selectedFarmFields.push(event.feature);
      map.data.overrideStyle(event.feature, {fillColor: 'yellow',});
      /*
      var bounds = new window.google.maps.LatLngBounds();
      event.feature.getGeometry().forEachLatLng((latLng) => {
        bounds.extend(latLng);
      });
      var center = bounds.getCenter();
      digiFields.push({
        centerLatitude: center.lat(),
        centerLongitude: center.lng(),
      });
      */
    }
  }

  const setStyles = (feature) => {
    var index = selectedFarmFields.findIndex(field => field.getId() === feature.getId());
    if (index > -1) {
      return {fillColor: 'yellow',};
    }
    else {
      return {fillColor: 'green',};
    }
  }

  const onBoundsChanged = _.debounce((bounds) => {
    dispatch(handleNonMappedFarmFieldsBoundsChange(bounds));
  }, 2000);

  const height = windowHeight - 64;

  var width = windowWidth;

  if (sidebarUnfoldable === true && sidebarVisible === true) {
    width -= 64;
  }
  else if (sidebarUnfoldable === false && sidebarVisible === true) {
    width -= 256;
  }

  return (    
    <div style={{flexDirection: 'row', display: 'flex',}}>
      <div style={{
        width: 300,
        height: height,
        overflowY: 'auto', 
      }}>
        <CContainer fluid>
          <CCard>
            <CCardBody>
              <CCardTitle>Map My Fields</CCardTitle>
              <CCardText>
                To map your farm fields, select a farm name below. Then zoom to your farm on the map and click your fields to select them. Once you have selected your farm fields, click the Save Mapping button.
              </CCardText>
            </CCardBody>
          </CCard>
          <CListGroup>
            {
              nonMappedFarmFields.map(field => {
                return (
                  <CListGroupItem 
                    key={field.fieldGUID}
                    active={selectedNonMappedFarmField?.fieldGUID === field.fieldGUID}
                    style={{cursor: 'pointer',}}
                    onClick={() => dispatch(userSelectedNonMappedFarmField(field))}
                    disabled={successfullySubmittedNonMappedFarmFields.findIndex(mappedField => mappedField.fieldGUID === field.fieldGUID) !== -1}>
                    {field.farmName}
                  </CListGroupItem>
                );
              })
            }
          </CListGroup>
        </CContainer>
      </div>
      <div ref={mapDivRef} style={{flexDirection: 'column', display: 'flex',}}>
        <div style={{
          height: '75px',
          width: width - 300,
          justifyContent: 'flex-start', 
          alignItems: 'center',
          display: 'flex',
          paddingLeft: '14px',
          flexDirection: 'row',
        }}>
          Currently Mapping: {selectedNonMappedFarmField !== null ? selectedNonMappedFarmField.farmName : 'No Farm Selected'}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <CLoadingButton
            loading={false}
            style={{height: 58,}}
            color='primary'
            variant='outline'
            onClick={() => dispatch(userTappedDrawFieldBooundaries())}>
            {showDrawFieldBoundaryControls === true ? 'Hide Draw Tools' : 'Show Draw Tools'}
          </CLoadingButton>
          {
            showDrawFieldBoundaryControls === true ? (
              <>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <CLoadingButton
                  loading={false}
                  style={{height: 58,}}
                  color='primary'
                  variant='outline'
                  onClick={() => dispatch(userTappedResetDrawing())}>
                  Reset Drawing
                </CLoadingButton>
              </>
            ) : null
          }
          {
            selectedNonMappedFarmField !== null ? (
              <>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <CLoadingButton
                  loading={submittingNonMappedFarmFields}
                  style={{height: 58,}}
                  color='primary'
                  variant='outline'
                  onClick={async () => {
                    if (showDrawFieldBoundaryControls === true) {
                      html2canvas(map.getDiv(), {useCORS: true,}).then((canvas) => {
                        const base64 = canvas.toDataURL('image/png');
                        dispatch(submitNonMappedFarmFieldsWithUserDrawings(map.getCenter().lat(), map.getCenter().lng(), base64));
                      });
                    }
                    else {
                      dispatch(submitNonMappedFarmFields(selectedFarmFields));
                    }
                  }}>
                  Save Farm Mapping
                </CLoadingButton>
              </>
            ) : null
          }
          
        </div>
        <div
          style={{
            width: width - 300,
            height: height - 75,
          }}>
          <Map
            mapId='MAP_MY_FIELDS'
            defaultCenter={{
              lng: -88.257311,
              lat: 40.112519,
            }} 
            defaultZoom={parseInt(process.env.REACT_APP_DEFAULT_MAP_ZOOM)}
            fullscreenControl={false}
            mapTypeId='hybrid'
            mapTypeControl={true}
            streetViewControl={false}
            onBoundsChanged={(bounds) => onBoundsChanged(bounds)}>
            {
              fetchingFarmFields === true ? (
                <MapControl position={ControlPosition.CENTER}>
                  <MapLoadingSpinner loadingText='Fetching Farm Fields' />
                </MapControl>
              ) : null
            }
            {
              fetchingDigiFarmFields === true ? (
                <MapControl position={ControlPosition.CENTER}>
                  <MapLoadingSpinner loadingText='Fetching Field Boundaries' />
                </MapControl>
              ) : null
            }
          </Map>
          <MapMyFieldDrawingTools visible={showDrawFieldBoundaryControls} />
        </div>
      </div>
      <CModal
        alignment='center'
        visible={mapMyFieldsSuccessModalIsVisible}>
        <CModalHeader closeButton={false}>
          <CModalTitle className={styles.cashBidsModalTitle}>
            Field Submission Success
          </CModalTitle>
          <CButton className={styles.modalCloseButton} onClick={() => dispatch(hideMapMyFieldsSuccessModal())}>
            <CIcon className={styles.modalCloseButtonIcon} icon={cilX} />
          </CButton>
        </CModalHeader>
        <CModalBody>
          Thank you for submitting your farm field mapping. Please allow us several days to process the mapping. 
        </CModalBody>
      </CModal>
    </div>
  );
}

export default MapMyFields;
